import { Configuration, PopupRequest } from "@azure/msal-browser";

const clientId = import.meta.env.VITE_ID_CLIENTE as string;
const locatorioId = import.meta.env.VITE_ID_LOCATORIO as string;

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${locatorioId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "memoryStorage", 
    storeAuthStateInCookie: false,
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email"],
};